/* istanbul ignore file */
import { UiThemeOverrider } from 'framework/uiTheme';
import AttachmentsListField from './AttachmentsListField';
import SearchResultImageLayout from './layout/AttachmentFieldLayout/SearchResultImageLayout';
import SearchResultDocumentLayout from './layout/AttachmentFieldLayout/SearchResultDocumentLayout';
import { Typography } from '@mui/material';

interface SearchResultAttachmentsListFieldProps {
  source: string;
  value?: string[];
  label?: string;
  isDownloadAvailable?: boolean;
  width?: number;
  budgetId?: StringOrNumber;
}

const SearchResultAttachmentsListField = (props: SearchResultAttachmentsListFieldProps) => (
  <Typography
    component="span"
    variant="inherit"
    sx={{
      '& .files-list__files': {
        display: 'inline-flex !important',
        '& > li': {
          margin: 0,
          height: '100%',
          display: 'inline-block',
          border: 0,
          '& button:first-child': {
            display: 'inline',
            padding: 0,
            border: 0,
            cursor: 'pointer',
            '&:hover, &:focus': {
              background: 'transparent',
              '& div, & span': {
                textDecoration: 'underline',
                color: 'primary.main',
              },
            },
            '& div, & span': {
              color: 'primary.main',
              marginRight: '5px',
              whiteSpace: 'normal',
              overflowWrap: 'anywhere',
              lineHeight: 1.5,
            },
          },
          '& .files-list__files-loader': {
            transform: 'translateY(3px)',
            height: '15px',
          },
        },
        '& .files-list__files-name': {
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
        },
      },
    }}
  >
    <UiThemeOverrider
      overriddenLayouts={{
        ArtifactImageLayout: SearchResultImageLayout,
        ArtifactDocumentLayout: SearchResultDocumentLayout,
      }}
    >
      <AttachmentsListField {...props} />
    </UiThemeOverrider>
  </Typography>
);

SearchResultAttachmentsListField.propTypes = {
  ...AttachmentsListField.propTypes,
};

export default SearchResultAttachmentsListField;
